<script lang="ts" setup>
import { VButton } from '@shared/component/VButton';
import VMenuButton from '@shared/component/VMenuButton/VMenuButton.vue';
import { useRelatietypeVoorMarktsegment } from '@relatie-lib/relatieGegevens/useRelatietypeVoorMarktsegment';

const { isParticulierMarktsegment, claimsGeladen } = useRelatietypeVoorMarktsegment();
</script>
<template>
  <VButton v-if="isParticulierMarktsegment" href="/app/crm/relatiegegevens/nieuw?soort=P">
    Nieuwe relatie
  </VButton>
  <VMenuButton
    v-else-if="claimsGeladen"
    :button-props="{}"
    menu-position="under"
    :menu-props="{
      model: [
        {
          label: 'Zakelijk',
          url: '/app/crm/relatiegegevens/nieuw?soort=Z',
          icon: 'far fa-building',
        },
        {
          label: 'Particulier',
          url: '/app/crm/relatiegegevens/nieuw?soort=P',
          icon: 'far fa-user',
        },
      ],
    }"
  >
    Nieuwe relatie
  </VMenuButton>
</template>
